import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {appdata} from "../../logic_tmp/appdata/AppData";
import {getCountersImpl} from "../../backend/connectors/JavaConnector";
import i18next from "i18next";
import {useHistory} from "react-router-dom";
import {calculatePricesAndCounts} from "../../logic/setup/PriceCalculator";
import {logInfo} from "../model/utils";

export function SpecialProposal({ onPricesUpdate }) {

    const {t} = useTranslation();
    const history = useHistory();
    let specialProposal = appdata.product["specialProposal"]
    const handleSpecialProposal = (e) => {
        e.preventDefault();
        console.log("SpecialProposal")
        logInfo(specialProposal.spKey + " "  + specialProposal.discountValue + " SP proposed!")
        appdata.leadSubAction = "SpecialProposal"
        appdata.spKey = specialProposal.spKey

        if (specialProposal["specialProposalActivity"] === "RECALCULATE")
        {

            console.log("RECALCULATE")
            appdata.spKeyRedim = specialProposal.spKey
            calculatePricesAndCounts(appdata, appdata.product)
            onPricesUpdate()
            console.log("RecalculateEND")
            history.push("/price");
        }
        else
        {
            history.push("/lead");
        }
    }

    let couponConfig = appdata.product["couponConfig"]
    let specialProposalConfig
    if (appdata.spKeyRedim)
        specialProposalConfig = appdata.product["specialProposalConfig"][appdata.spKeyRedim]
    return (
        <div>
            {(specialProposal !== undefined && specialProposal["status"] === "ACTIVE" && appdata.spKeyRedim === undefined)?
                <div>
                    <h2 className="offer-pay__title bigfont">
                    </h2>
                    <h2 className="bigfont redfont">
                        <br/>
                        {t(specialProposal["headerKey"])}
                        <br/>
                        {t(specialProposal["motivationTextKey"],{discountValue:specialProposal.discountValue})}
                    </h2>
                    <div>
                        {(specialProposal !== undefined && specialProposal["specialProposalActivity"] !== "MESSAGE")?
                        <div className="app-button d-flex justify-content-around">
                            <button id="nextButtonSpecial" onClick={(e) => handleSpecialProposal(e)}
                                    className="g-btn app-btn-further next-step-btn">
                                <span> {t(specialProposal["buttonTextKey"],{discountValue:specialProposal.discountValue})}</span>
                            </button>
                        </div>:<div></div>}
                    </div>
                </div>
                : <div></div>}

        </div>
    )
}


